import { Component, ViewChild, OnInit } from '@angular/core';
import { CrudPatientComponent } from '../crud-patient/crud-patient.component';
import { CrudPatientMode } from '../crud-patient/crud-patient.facade';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { VisitsViewComponent } from '../visits-view/visits-view.component';
import { TreatmentsViewComponent } from '../treatments-view/treatments-view.component';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { FormAssignmentsComponent } from '../form-assignments/form-assignments.component';
import { DividerModule } from 'primeng/divider';
import { ActionMenuEvent, PatientActionsMenuComponent } from '../../global-components/patient-actions-menu/patient-actions-menu.component';
import { GlobalMessageService } from '../../global-services/global-message.service';
import { PremoService } from '../../global-services/premo.service';
import { DialogModule } from 'primeng/dialog';
import { CrudTreatmentComponent } from '../crud-treatment/crud-treatment.component';

@Component({
  standalone: true,
  templateUrl: './patient-dashboard.component.html',
  imports: [
    ...COMMON_IMPORTS,
    CrudPatientComponent,
    ButtonModule,
    VisitsViewComponent,
    TreatmentsViewComponent,
    FormAssignmentsComponent,
    DividerModule,
    PatientActionsMenuComponent,
    DialogModule,
    CrudTreatmentComponent,
  ],
})
export class PatientDashboardComponent implements OnInit {
  public orgId: string;
  public patientId: string;
  public CrudPatientMode = CrudPatientMode;
  public crudPatientMode: CrudPatientMode = CrudPatientMode.READ;

  @ViewChild('visitsView') visitsViewComponent!: VisitsViewComponent;
  @ViewChild('treatmentsView') treatmentsViewComponent!: TreatmentsViewComponent;
  @ViewChild(CrudPatientComponent) crudPatientComponent!: CrudPatientComponent;

  public showTreatmentDialog = false;

  public constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly premoService: PremoService,
    private readonly messageService: GlobalMessageService
  ) {
    this.orgId = this.route.snapshot.paramMap.get('orgId')!;
    this.patientId = this.route.snapshot.paramMap.get('patientId')!;
  }

  public ngOnInit(): void {
  }

  public toggleCrudPatientEditMode() {
    const oldMode = this.crudPatientMode;
    const newMode = oldMode === CrudPatientMode.READ ? CrudPatientMode.UPDATE : CrudPatientMode.READ;
    if (oldMode === CrudPatientMode.READ && newMode === CrudPatientMode.UPDATE) {
      this.crudPatientComponent.expandAccordion();
    }
    this.crudPatientMode = newMode;
  }

  public navigateToAddVisit() {
    this.router.navigate(['/orgs', this.orgId, 'patients', this.patientId, "visit", 'create']);
  }

  public navigateToAssignForm() {
    this.router.navigate(['/orgs', this.orgId, 'patients', this.patientId, 'form-assignments', 'create']);
  }

  public showAddTreatment() {
    this.showTreatmentDialog = true;
  }

  public async onTreatmentSubmit() {
    await this.treatmentsViewComponent.refreshTreatments();
    this.showTreatmentDialog = false;
  }

  public async calculatePremo() {
    if (!(await this.premoService.canCalculatePremo(this.orgId, this.patientId))) {
      this.messageService.showError("Calculate Premo Error", "Can't calculate premo as patient has no visits");
      return;
    }
    this.router.navigate(["orgs", this.orgId, "patients", this.patientId, "calculate-premo"]);
  }

  public async onMenuEvent(action: ActionMenuEvent) {
    switch (action) {
      case ActionMenuEvent.ADD_TREATMENT:
        await this.treatmentsViewComponent.refreshTreatments();
        break;
      default:
        break;
    }
  }
}